// Animated heartbeat / ECG line. Pure SVG.
export default function HeartbeatLine({ className = "", color = "#FF3B30", height = 60 }) {
    return (
        <svg
            viewBox="0 0 1200 80"
            preserveAspectRatio="none"
            className={`block w-full ${className}`}
            style={{ height }}
            aria-hidden="true"
        >
            <line x1="0" y1="40" x2="1200" y2="40" stroke="#0A0A0A" strokeWidth="1" strokeOpacity="0.08" />
            <path
                d="M0 40 L150 40 L180 40 L210 20 L240 60 L260 10 L280 70 L300 40 L450 40 L480 40 L510 25 L540 55 L560 12 L580 68 L600 40 L750 40 L780 40 L810 20 L840 60 L860 10 L880 70 L900 40 L1200 40"
                fill="none"
                stroke={color}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="heartbeat-path"
            />
        </svg>
    );
}
